import React from 'react';
import { useTranslation } from 'react-i18next';
import Tag from '../../models/Tag';
import RenderUser from '../RenderUser';

interface TagItemProps {
    tag: Tag;
    openModal: (tag: Tag) => void;
    openDeleteModal: (tag: Tag) => void;
    visibleCheck?: boolean;
    isChecked?: boolean;
    onChecked?: (tag: Tag) => void;
};

const TagItem: React.FC<TagItemProps> = ({ tag, openModal, openDeleteModal, ...props }) => {

    const [t, i18n] = useTranslation();

    const isChecked = props.isChecked ?? false;
    const batchActive = props.visibleCheck ?? false;

    const _formatDate = (dateStr: string): string => {
        if (!dateStr) return '\u2014';
        try {
            return new Date(dateStr).toLocaleDateString(i18n.language, {
                year: 'numeric', month: 'short', day: 'numeric',
            });
        } catch {
            return dateStr;
        }
    };

    return (
        <div
            className="card mb-3"
            style={batchActive ? { cursor: 'pointer' } : undefined}
            onClick={batchActive ? () => props.onChecked?.(tag) : undefined}
        >
            <div className={`card-body screen-item${isChecked ? ' checked' : ''}`}>

                {/* Name + description */}
                <div className="screen-item__info">
                    <div className="screen-item__name">
                        <i className="iconsminds-tag" style={{ flexShrink: 0 }}></i>
                        <span className="ml-2">{ tag.name }</span>
                    </div>
                    { tag.description && (
                        <span className="tag-item__description">{ tag.description }</span>
                    )}
                </div>

                {/* Last update */}
                <div
                    className="screen-item__playing"
                    onClick={batchActive ? (e) => e.stopPropagation() : undefined}
                >
                    <div className="screen-item__playing__title">{ t('Last_update') }</div>
                    <span className="widget-item__meta-value">{ _formatDate(tag.updated_at) }</span>
                </div>

                {/* Actions */}
                <div className="screen-item__actions">
                    <RenderUser item={tag} />
                    <button
                        type="button"
                        style={{ background: 'none', border: 'none', padding: 0 }}
                        onClick={(e) => {
                            if (batchActive) { e.stopPropagation(); return; }
                            openModal(tag);
                        }}
                    >
                        <i className="iconsminds-pen screen-item__options pointer"></i>
                    </button>
                    <button
                        type="button"
                        style={{ background: 'none', border: 'none', padding: 0 }}
                        onClick={(e) => {
                            if (batchActive) { e.stopPropagation(); return; }
                            openDeleteModal(tag);
                        }}
                    >
                        <i className="iconsminds-close screen-item__options color-secondary-color pointer"></i>
                    </button>
                </div>

            </div>
        </div>
    );

};

export default React.memo(TagItem);
